import { Tag, Space, Button, Tooltip, Typography } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { STORES } from "../BlogsTable/stores";

const labelForHash = (hash) =>
  STORES.find((s) => s.hash === hash)?.label || "";

const buildColumns = ({ onEdit, onDelete, page = 1, limit = 20 }) => [
  {
    title: "Sr. No",
    key: "sno",
    width: 80,
    align: "center",
    render: (_, __, index) => (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {(page - 1) * limit + index + 1}
      </Typography.Text>
    ),
  },
  {
    title: "Store",
    dataIndex: "storeHash",
    key: "storeHash",
    width: 170,
    sorter: (a, b) => labelForHash(a.storeHash).localeCompare(labelForHash(b.storeHash)),
    render: (val) => {
      if (!val) return "—";
      const label = labelForHash(val);
      return (
        <Space size={4} direction="vertical" style={{ lineHeight: 1.2 }}>
          {label ? (
            <Tag color="geekblue" style={{ marginRight: 0 }}>
              {label}
            </Tag>
          ) : (
            <Typography.Text type="secondary" style={{ fontSize: 11 }}>
              Unknown store
            </Typography.Text>
          )}
          <Tooltip title={val}>
            <Typography.Text code style={{ fontSize: 11 }}>
              {val}
            </Typography.Text>
          </Tooltip>
        </Space>
      );
    },
  },
  {
    title: "Bucket Key",
    dataIndex: "bucketKey",
    key: "bucketKey",
    width: 180,
    sorter: (a, b) => String(a.bucketKey || "").localeCompare(String(b.bucketKey || "")),
    render: (val) => <Typography.Text code>{val}</Typography.Text>,
  },
  {
    title: "Display Name",
    dataIndex: "displayName",
    key: "displayName",
    ellipsis: true,
    sorter: (a, b) => String(a.displayName || "").localeCompare(String(b.displayName || "")),
  },
  {
    title: "Sort Order",
    dataIndex: "sortOrder",
    key: "sortOrder",
    width: 150,
    align: "center",
    sorter: (a, b) => Number(a.sortOrder ?? 0) - Number(b.sortOrder ?? 0),
  },
  {
    title: "Actions",
    key: "actions",
    width: 120,
    fixed: "right",
    align: "center",
    render: (_, record) => (
      <Space onClick={(e) => e.stopPropagation()}>
        <Tooltip title="Edit">
          <Button
            size="small"
            icon={<EditOutlined />}
            onClick={() => onEdit?.(record)}
          />
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            size="small"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete?.(record)}
          />
        </Tooltip>
      </Space>
    ),
  },
];

export default buildColumns;
